export default "__VITE_ASSET__Dy51VoQH__"